// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3teap","filesListContainer":"PosDisputesFiles_filesListContainer__167w3","filesButton":"PosDisputesFiles_filesButton__se_6j"};